import { CreditSummaryStyles } from '../../models';

export const creditSummaryStyles: CreditSummaryStyles = {
  backgroundColor: '#f7ebd3',
  colorTheme: 'light',
  decimalPointsUi: {
    fontColor: '#0b1f66',
    fontSize: '0.9375rem',
    fontType: 'Whitney-Semibold'
  },
  statementCreditUi: {
    fontColor: '#0b1f66',
    fontSize: '0.9375rem',
    fontType: 'Whitney-Medium'
  },
  statementCreditLabel: {
    fontColor: '#0b1f66',
    fontSize: '0.9375rem',
    fontType: 'Whitney-Medium'
  },
  total: {
    fontColor: '#0b1f66',
    fontSize: '1.5rem',
    fontType: 'Whitney-Semibold'
  },
  totalLabel: {
    fontColor: '#0b1f66',
    fontSize: '1.125rem',
    fontType: 'Whitney-Semibold'
  }
};
